var data$9 = {
  empty: { title: "Hier gibt es nichts zu sehen" },
  error: {
    title: "Irgendetwas ist schief gegangen",
    description: 'Klicken Sie auf "Aktualisieren" und versuchen Sie es erneut.',
    refresh: "Aktualisieren",
  },
};
data$9.empty;
data$9.error;

var data$8 = {
  empty: { title: "There's nothing to see here" },
  error: {
    title: "Something went wrong",
    description: "Click refresh and try again.",
    refresh: "Refresh",
  },
};
data$8.empty;
data$8.error;

var data$7 = {
  empty: { title: "Aquí no hay nada" },
  error: {
    title: "Algo salió mal",
    description: "Haga clic en actualizar para intentarlo de nuevo.",
    refresh: "Actualizar",
  },
};
data$7.empty;
data$7.error;

var data$6 = {
  empty: { title: "Aquí no hay nada." },
  error: {
    title: "Algo falló",
    description: "Haga clic en Actualizar para intentarlo de nuevo.",
    refresh: "Actualizar",
  },
};
data$6.empty;
data$6.error;

var data$5 = {
  empty: { title: "Aucune information n'est disponible" },
  error: {
    title: "Une erreur s'est produite",
    description: "Cliquez sur Actualiser, puis réessayez.",
    refresh: "Actualiser",
  },
};
data$5.empty;
data$5.error;

var data$4 = {
  empty: { title: "Qui non c'è nulla da vedere" },
  error: {
    title: "Si è verificato un errore",
    description: "Fai clic su Aggiorna e riprova.",
    refresh: "Aggiorna",
  },
};
data$4.empty;
data$4.error;

var data$3 = {
  empty: { title: "ここに表示するものはありません" },
  error: {
    title: "問題が発生しました",
    description: "[更新] をクリックしてもう一度お試しください。",
    refresh: "更新",
  },
};
data$3.empty;
data$3.error;

var data$2 = {
  empty: { title: "표시할 내용이 없습니다" },
  error: {
    title: "오류가 발생했습니다",
    description: "새로고침을 클릭하고 다시 시도하세요.",
    refresh: "새로고침",
  },
};
data$2.empty;
data$2.error;

var data$1 = {
  empty: { title: "Não há nada para ver aqui" },
  error: {
    title: "Ocorreu um erro",
    description: "Clique em Atualizar e tente novamente.",
    refresh: "Atualizar",
  },
};
data$1.empty;
data$1.error;

var data = {
  empty: { title: "此处没有可查看的内容" },
  error: {
    title: "出现错误",
    description: "请单击“刷新”，然后重试。",
    refresh: "刷新",
  },
};
data.empty;
data.error;

var loadingStateLocales = /*#__PURE__*/ Object.freeze({
  __proto__: null,
  de: data$9,
  en: data$8,
  es: data$7,
  esMX: data$6,
  fr: data$5,
  it: data$4,
  ja: data$3,
  ko: data$2,
  ptBR: data$1,
  zhCN: data,
});

export { loadingStateLocales as l };
